<template>
  <CCol col="12" xl="12" class="p-0" style="font-family: IRANSans">
    <CCard class="p-0">
      <CCardHeader
        class="d-flex justify-content-between align-items-center bg-secondary"
      >
        <h5 class="text-light m-0 p-0">نمودار آنلاین</h5>
        <date-picker
          class="p-0 m-0"
          v-model="date"
          :value="date"
          @change="search(date)"
        ></date-picker>
      </CCardHeader>
      <highcharts
        class="hc"
        :options="chartOptionsTemp"
        ref="chart"
      ></highcharts>

      <!-- <CChartLine
        dir="ltr"
        :datasets="defaultDatasets"
        :options="defaultOptions"
        :labels="chartData.labels"
      /> -->
    </CCard>
  </CCol>
</template>

<script>
import { CChartLine } from "@coreui/vue-chartjs";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import axios from "axios";
import { Values } from "../../commonValues";

import Vue from "vue";
import HighchartsVue from "highcharts-vue";
Vue.use(HighchartsVue);

import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import stockInit from "highcharts/modules/stock";
import offlineExporting from "highcharts/modules/offline-exporting";

stockInit(Highcharts);
exportingInit(Highcharts);
offlineExporting(Highcharts);



Highcharts.dateFormats = {
  a: function (ts) {
    return moment(ts).format("dddd");
  },
  A: function (ts) {
    return moment(ts).format("dddd");
  },
  d: function (ts) {
    return moment(ts).format("DD");
  },
  e: function (ts) {
    return moment(ts).format("D");
  },
  b: function (ts) {
    return moment(ts).format("MMMM");
  },
  B: function (ts) {
    return moment(ts).format("MMMM");
  },
  m: function (ts) {
    return moment(ts).format("MM");
  },
  y: function (ts) {
    return moment(ts).format("YY");
  },
  Y: function (ts) {
    return moment(ts).format("YYYY");
  },
  W: function (ts) {
    return moment(ts).format("ww");
  },

  
};



export default {
  props: ["serialNumber, sensorType, sensorIndex", "sensorName", "sensorDate"],
  name: "CChartLineExample",
  components: {
    CChartLine,
    datePicker: VuePersianDatetimePicker,
  },

  data() {
    return {
      date: "",
      chartData: {
        label: "",
        backgroundColor: "rgb(228,102,81,0.2)",
        data: [],
        labels: [],
      },

      chartOptions: {
        chart: {
          type: "spline",
          title: "---",
          zoomType: "xy",
          backgroundColor: "rgb(224,224,224,0.8)",
        },
        title: {
          text: "---",
        },

         tooltip: {
          useHTML: true,
          headerFormat:
            '<p style="direction:rtl; text-align:center; fontFamily: IRANSans;">{point.key} </p>',
          pointFormat:
            '<h6 style="direction:rtl; text-align:center; fontFamily: IRANSans;">{series.name} </h6>' +
            '<h5 style="direction:ltr; text-align:center; ; fontFamily: IRANSans;"> {point.y} </h5>',
        },

        xAxis: {
          categories: [],
        },
        // tooltip: {
        //   crosshairs: true,
        //   shared: true
        // },
        credits: {
          enabled: false,
        },
        // plotOptions: {
        //   spline: {
        //     marker: {
        //       radius: 4,
        //       lineColor: "#666666",
        //       lineWidth: 1
        //     }
        //   }
        // },
        series: [{ name: "Temp", data: [] }],
      },

      chartOptionsTemp: {
        
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                 'viewFullscreen',
                {
                  textKey: "printChart",
                  onclick: function () {
                    this.print();
                  },
                },
                {
                  separator: true,
                },
                {
                  textKey: "downloadPNG",
                  onclick: function () {
                    this.exportChart();
                  },
                },
                {
                  textKey: "downloadJPEG",
                  onclick: function () {
                    this.exportChart({
                      type: "image/jpeg",
                    });
                  },
                },
                {
                  textKey: "downloadPDF",
                  onclick: function () {
                    this.exportChart({
                      type: "application/pdf",
                    });
                  },
                },
                {
                  textKey: "downloadSVG",
                  onclick: function () {
                    this.exportChart({
                      type: "image/svg+xml",
                    });
                  },
                },
              ],
            },
          },
        },

        chart: {
          type: "spline",
          title: "Hassaan",
          zoomType: "xy",
          backgroundColor: "rgb(224,224,224,0.2)",
        },
        legend: {
          itemStyle: {
            fontFamily: "IRANSans",
          },
        },
        title: {
          text: "---",
          style: {
            fontFamily: "IRANSans",
          },
        },

         tooltip: {
          useHTML: true,
          headerFormat:
            '<p style="direction:rtl; text-align:center; fontFamily: IRANSans;">{point.key} </p>',
          pointFormat:
            '<h6 style="direction:rtl; text-align:center; fontFamily: IRANSans;">{series.name} </h6>' +
            '<h5 style="direction:ltr; text-align:center; ; fontFamily: IRANSans;"> {point.y} </h5>',
        },

        yAxis: {
          max: null,
          min: null,
          title: {
            text: "°C",
          },
          plotLines: [
            {
              color: "red",
              width: 2,
              value: 20,
            },
            {
              color: "blue",
              width: 2,
              value: 25,
            },
          ],
          plotBands: [
            {
              color: "#CEECF5", // Color value
              from: 0, // Start of the plot band
              to: 10, // End of the plot band
            },
            {
              color: "#E3F6CE", // Color value
              from: 10, // Start of the plot band
              to: 15, // End of the plot band
            },
            {
              color: "#F6CECE", // Color value
              from: 15, // Start of the plot band
              to: 20, // End of the plot band
            },
          ],
        },

        xAxis: {
          // categories: [],

          type: "datetime",

          // tickInterval: 10,
        },
        // tooltip: {
        //   crosshairs: true,
        //   shared: true
        // },
        credits: {
          enabled: false,
        },
        // plotOptions: {
        //   spline: {
        //     marker: {
        //       radius: 4,
        //       lineColor: "#666666",
        //       lineWidth: 1
        //     }
        //   }
        // },
        plotOptions: {
          series: {
            turboThreshold: 0, //set it to a larger threshold, it is by default to 1000
          },
        },
        series: [],
      },

      

    };
  },
  computed: {
    defaultDatasets() {
      return [
        {
          label: this.chartData.label,
          backgroundColor: this.chartData.backgroundColor,
          data: this.chartData.data,
        },
      ];
    },
    defaultOptions() {
      return {
        // scales: {
        //   y: {
        //     beginAtZero: true,
        //   },
        // },
        title: {
          display: true,
          text: "سنسور " + this.chartData.label,
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            color: "rgb(255, 99, 132)",
          },
        },
        scales: {
          yAxes: [
            {
              beginAtZero: true,
              // ticks: {
              //   // Include a dollar sign in the ticks
              //   callback: function (value, index, values) {
              //     return value + " $ ";
              //   },
              // },
            },
          ],
        },
      };
    },
  },
  mounted() {
    this.date = this.$route.params.sensorDate;
    axios
      .post(
        Values.serverIp + "SensorValue/GetSensorValuesFromDateTimeToDateTime",
        {
          deviceId: this.$route.params.serialNumber,
          sensorType: this.$route.params.sensorType,
          sensorIndex: this.$route.params.sensorIndex,
          fromDate: this.$route.params.sensorDate,
          toDate: "",
          fromTime: "",
          toTime: "",
        }
      )
      .then((response) => {
        if (response.status == 200) {
          console.log(response.data);

          let values = response.data.data.map(function (v) {
            return v.y;
          });
          var min = Math.min.apply(null, values) - 10;
          var max = Math.max.apply(null, values) + 10;

          this.chartOptionsTemp.series.push({
            data: response.data.data,
            name: response.data.label,
          });

          this.chartOptionsTemp.title.text = " سنسور " + response.data.label;
          this.chartOptionsTemp.yAxis.plotLines[0].value =
            response.data.alarmMax == null
              ? response.data.data[0].y
              : response.data.alarmMax;
          this.chartOptionsTemp.yAxis.plotLines[1].value =
            response.data.alarmMin == null
              ? response.data.data[0].y + 15
              : response.data.alarmMin;
          this.chartOptionsTemp.yAxis.max = max; //response.data.alarmMax ==null ? response.data.data[0].y+15 :response.data.alarmMax+ 15;
          this.chartOptionsTemp.yAxis.min = min; //response.data.alarmMin ==null ? response.data.data[0].y-15 :response.data.alarmMin- 15;

          this.chartOptionsTemp.yAxis.plotBands[0].from = min;
          // response.data.alarmMin == null
          //   ? response.data.data[0].y - 15
          //   : response.data.alarmMin - 15;
          this.chartOptionsTemp.yAxis.plotBands[0].to =
            response.data.alarmMin == null
              ? response.data.data[0].y - 15
              : response.data.alarmMin;

          this.chartOptionsTemp.yAxis.plotBands[1].from =
            response.data.alarmMin == null
              ? response.data.data[0].y - 15
              : response.data.alarmMin;
          this.chartOptionsTemp.yAxis.plotBands[1].to =
            response.data.alarmMax == null
              ? response.data.data[0].y + 15
              : response.data.alarmMax;

          this.chartOptionsTemp.yAxis.plotBands[2].from =
            response.data.alarmMax == null
              ? response.data.data[0].y + 15
              : response.data.alarmMax;
          this.chartOptionsTemp.yAxis.plotBands[2].to = max;

          // this.chartOptionsTemp.title.text = " سنسور " + response.data.label;
          // this.chartOptionsTemp.yAxis.plotLines[0].value =
          //   response.data.alarmHighLimit;
          // this.chartOptionsTemp.yAxis.plotLines[1].value =
          //   response.data.alarmLowLimit;
          // this.chartOptionsTemp.yAxis.max = response.data.alarmHighLimit + 15;
          // this.chartOptionsTemp.yAxis.min = response.data.alarmLowLimit - 15;
          // //console.log(this.chartOptionsTemp.yAxis.plotBands[0]);
          // this.chartOptionsTemp.yAxis.plotBands[0].from =
          //   response.data.alarmLowLimit - 15;
          // this.chartOptionsTemp.yAxis.plotBands[0].to =
          //   response.data.alarmLowLimit;

          // this.chartOptionsTemp.yAxis.plotBands[1].from =
          //   response.data.alarmLowLimit;
          // this.chartOptionsTemp.yAxis.plotBands[1].to =
          //   response.data.alarmHighLimit;

          // this.chartOptionsTemp.yAxis.plotBands[2].from =
          //   response.data.alarmHighLimit;
          // this.chartOptionsTemp.yAxis.plotBands[2].to =
          //   response.data.alarmHighLimit + 15;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },

  methods: {
    search(data) {
      axios
        .post(
          Values.serverIp + "SensorValue/GetSensorValuesFromDateTimeToDateTime",
          {
            deviceId: this.$route.params.serialNumber,
            sensorType: this.$route.params.sensorType,
            sensorIndex: this.$route.params.sensorIndex,
            fromDate: data,
            toDate: data,
            fromTime: "",
            toTime: "",
          }
        )
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data);

            this.chartOptionsTemp.series = [];

            let values = response.data.data.map(function (v) {
              return v.y;
            });
            var min = Math.min.apply(null, values) - 10;
            var max = Math.max.apply(null, values) + 10;

            this.chartOptionsTemp.series.push({
              data: response.data.data,
              name: response.data.label,
            });

            this.chartOptionsTemp.title.text = " سنسور " + response.data.label;
            this.chartOptionsTemp.yAxis.plotLines[0].value =
              response.data.alarmMax == null
                ? response.data.data[0].y
                : response.data.alarmMax;
            this.chartOptionsTemp.yAxis.plotLines[1].value =
              response.data.alarmMin == null
                ? response.data.data[0].y + 15
                : response.data.alarmMin;
            this.chartOptionsTemp.yAxis.max = max; //response.data.alarmMax ==null ? response.data.data[0].y+15 :response.data.alarmMax+ 15;
            this.chartOptionsTemp.yAxis.min = min; //response.data.alarmMin ==null ? response.data.data[0].y-15 :response.data.alarmMin- 15;

            this.chartOptionsTemp.yAxis.plotBands[0].from = min;
            // response.data.alarmMin == null
            //   ? response.data.data[0].y - 15
            //   : response.data.alarmMin - 15;
            this.chartOptionsTemp.yAxis.plotBands[0].to =
              response.data.alarmMin == null
                ? response.data.data[0].y - 15
                : response.data.alarmMin;

            this.chartOptionsTemp.yAxis.plotBands[1].from =
              response.data.alarmMin == null
                ? response.data.data[0].y - 15
                : response.data.alarmMin;
            this.chartOptionsTemp.yAxis.plotBands[1].to =
              response.data.alarmMax == null
                ? response.data.data[0].y + 15
                : response.data.alarmMax;

            this.chartOptionsTemp.yAxis.plotBands[2].from =
              response.data.alarmMax == null
                ? response.data.data[0].y + 15
                : response.data.alarmMax;
            this.chartOptionsTemp.yAxis.plotBands[2].to = max;
            // this.chartData = response.data;

            // this.chartOptions.xAxis.categories = response.data.labels;
            // this.chartOptions.series[0].data = response.data.data;
            // this.chartOptions.series[0].name = response.data.label;
            // this.chartOptions.title.text = " سنسور" + response.data.label;

            //this.chartJs();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
